module.exports = __webpack_public_path__ + "img/cooperate_qy_12@2x.d30b789a.png";